<template>
  <div
    ref="chart"
    class="bs-charts"
    v-loading="loadingFlag"
    element-loading-spinner="el-icon-loading"
    element-loading-background="#151d32"
  >
  </div>
</template>

<script>
let echarts = require("echarts");
import { getOption } from "./lineChartsConfig";
export default {
  props: ["message","type",],
  data() {
    return {
      oEchart:null,
      loadingFlag: false,
      flag: 1,
      inData: [],
      outData: [1,2,3,4,5],
      stock: {
        inWeek: [],
        inMonth: [],
        outWeek: [],
        outMonth: []
      },
      week: [],
      week2: [],
      lineData: [],
    };
  },

  created() {
    //this.getCountOfStock();
  },
  methods: {
   
    getCountOfStock() {
      this.loadingFlag = true;
      this.$API
        .getCountOfStock()
        .then(res => {
          let jsonData = JSON.stringify(res.data.inMonth[0]); // 转成JSON格式
          for (let val of res.data.inMonth) {
            for (let i in val) {
              this.stock.inMonth.push(val[i]);
            }
          }
          for (let val of res.data.inWeek) {
            for (let i in val) {
              this.stock.inWeek.push(val[i]);
              //console.log(i);
            }
          }
          for (let val of res.data.outMonth) {
            for (let i in val) {
              this.stock.outMonth.push(val[i]);
            }
          }
          for (let val of res.data.outWeek) {
            for (let i in val) {
              this.stock.outWeek.push(val[i]);
              this.week.push(i);
            }
          }
          this.dateToWeek();
          //console.log("this:" + JSON.stringify(this.lineData1));
          this.setData(this.inData, this.outData, this.lineData);
          this.loadingFlag = false;
        })
        .catch(err => {});
    },
    dateToWeek() {
      var dayCycleArray = [
        "周日",
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六"
      ];
      let k = 0;
      for (let i = 0; i < 7; i++) {
        this.week2[i] = new Date(this.week[i]);
        var dayCycle = this.week2[i].getDay();
        //console.log("week:" + dayCycle);
        for (let j = 0; j < 7; j++) {
          if (dayCycle == j) {
            dayCycle = dayCycleArray[j];
            //console.log("week:" + dayCycle);
            this.lineData1[k++].value = dayCycle;
            //console.log(JSON.stringify(this.lineData1[j]));
          }
        }
      }
      //console.log(JSON.stringify(this.lineData1));
    },
    setData(inData, outData, lineData) {
      let _this = this;
      _this.oEchart = echarts.init(_this.$refs.chart);
      _this.oEchart.setOption(getOption(inData, outData, lineData));
      window.addEventListener('resize',function(){
        _this.oEchart.resize();
      })
    },
    //虚拟币消耗情况
  async CornConsumeCondition(){
     const {data} = await this.$API.CornConsumeCondition({type:this.type}) 
     this.lineData = Object.keys(data)
     this.inData = Object.values(data)
     this.setData(this.inData, this.outData, this.lineData);
    }
  },
   watch: {
    type: function(val){
      this.CornConsumeCondition()
    }
 },
 
  created(){
    this.CornConsumeCondition()
  }
};
</script>


<style lang="scss" scoped>
.bs-charts {
  height: calc(100% - 33px);
  canvas{
      height: 100% !important;
      width: 100% !important;
  }
}
</style>
